"use strict";
require('./CompanyPublicationOrderService.js');
require('../../products/CompanyProductsService.js');
var LIMIT = 20;

CompanyPublicationOrderReportCtrl.$inject = [
  '$scope',
  '$stateParams',
  '$modal',
  '$state',
  '$filter',
  'CompanyPublicationOrderService',
  'order',
  'config',
  'deliveries'];
function CompanyPublicationOrderReportCtrl(
  $scope,
  $stateParams,
  $modal,
  $state,
  $filter,
  orderService,
  order,
  config,
  deliveries) {

  $scope.order = order;
  $scope.deliveries = deliveries;
  $scope.currentPage   = $stateParams.page|0;

  $scope.orderDataQuery = $stateParams.t || "";
  var startDate = Date.parse($stateParams.from);
  var endDate   = Date.parse($stateParams.to);

  $scope.orderDataSpan  = {
    from: startDate ? new Date(startDate) : null,
    to:   endDate   ? new Date(endDate)   : null
  };

  var angularModal;
  $scope.showModalActiveOrder = function(d) {
     angularModal = $modal({
      scope: $scope,
      prefixEvent: "modalOrder",
      controller: ['$scope', 'delivery', function($scope, delivery) {
        $scope.delivery = delivery;
        $scope.activeOrder = function() {
          orderService.updateDelivery({
            companyId: $stateParams.companyId,
            publicationId: $stateParams.publicationId,
            massoptimeringId: $scope.order.id,
            deliveryId: $scope.delivery.id
          }, {}, function(){
            d.active = !d.active;
          });
        };
      }],
      templateUrl: 'partials/company/publications/order-report/confirm-delete.html',
      show: true,
      resolve: {
        delivery: function() {
          return d;
        }
      }
    });
  };

  $scope.$on('modalOrder.hide', function(){
    angularModal.destroy();
    angularModal = null;
  });


  $scope.toggleActiveOrder = function(d) {
    orderService.updateDelivery({
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      massoptimeringId: $scope.order.id,
      deliveryId: d.id
    }, {}, function(){
      d.active = !d.active;
    });
  };

  $scope.search = function(event) {
    event.preventDefault();

    var query = {
      page: 0,
      t: $scope.orderDataQuery
    };

    if ($scope.orderDataSpan.from) {
      query.from = $filter('date')($scope.orderDataSpan.from, "yyyy-MM-dd");
    }

    if ($scope.orderDataSpan.to) {
      query.to = $filter('date')($scope.orderDataSpan.to, "yyyy-MM-dd");
    }

    $state.go("root.company.publication.order-report", query, { location: "replace" });
  };

  $scope.downloadExcel = function() {
    var url = config.apiBase + '/companies/' + $scope.companyId + '/publications/' + $stateParams.publicationId + '/export-deliveries?all=true&type=order&id=' + $scope.order.id + '&lang=' + window.localStorage.language;
    if ($scope.orderDataSpan.from) {
      url = url.concat('&from=', $filter('date')($scope.orderDataSpan.from, "yyyy-MM-dd"));
    }

    if ($scope.orderDataSpan.to) {
      url = url.concat('&to=', $filter('date')($scope.orderDataSpan.to, "yyyy-MM-dd"));
    }

    if ($scope.orderDataQuery) {
      url = url.concat('&t=', $scope.orderDataQuery);
    }

    var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
    if (true === iOS) {
      window.open(url, '_self');
      return;
    }

    var elm = angular.element(document.querySelector('body'));
    var iFrame = elm.find('#downloadWindow');
    if (!(iFrame && iFrame.length > 0)) {
      iFrame = angular.element("<iframe id='downloadWindow' style='position:fixed;display:none;top:-1px;left:-1px;'/>");
      elm.append(iFrame);
    }

    iFrame.attr('src',url);
  };
}

CompanyPublicationOrderReportCtrl.resolve = {
  order: ['CompanyPublicationOrderService', '$stateParams', function(orderService, $stateParams){
    return orderService.get({
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId
    }).$promise;
  }],

  deliveries: [
    'CompanyPublicationOrderService',
    '$stateParams',
    'order',
    function(orderService, $stateParams, order){
    var filter = {
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      massoptimeringId: order.id,
      offset: ($stateParams.page|0) * LIMIT,
      limit:  LIMIT + 1
    };

    if ($stateParams.from) {
      filter.from = $stateParams.from;
    }

    if ($stateParams.to) {
      filter.to = $stateParams.to;
    }

    if($stateParams.t) {
      filter.t = $stateParams.t;
    }
    return orderService.queryDeliveries(filter).$promise;
  }]
};

module.exports = CompanyPublicationOrderReportCtrl;

angular.module("dokiv")
  .controller("CompanyPublicationOrderReportCtrl", CompanyPublicationOrderReportCtrl);






//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/order/CompanyPublicationOrderReportCtrl.js
// module id = 403
// module chunks = 0